import { getProjectData } from '@appmaker/core/store/project';

export const PreviewDevice = ({ image, title, message }) => {
	const { projectData } = getProjectData();
	const { icon, name } = projectData;
	return (
		<div
			className="w-full p-5 relative overflow-hidden"
			style={{ height: '480px' }}
		>
			<div
				className="absolute inset-0 bg-cover bg-no-repeat bg-top"
				style={{ backgroundImage: 'url("/images/misc/iwall.png")' }}
			/>
			<div className="bg-white rounded-lg p-2 relative z-10 backdrop-filter backdrop-blur-lg bg-opacity-80 top-16">
				<div className="flex items-center gap-2 ">
					<img src={icon} alt="icon" className="w-6 h-6" />
					<div className="text-xs flex-1">{name}</div>
					<div className="text-xs">
						<span className="text-gray-500">now</span>
					</div>
				</div>
				<div className="mt-1">
					<h4 className="font-medium text-sm text-gray-900 mb-0.5">
						{title || 'Start editing to see preview'}
					</h4>
					<p className="text-gray-600 text-xs">{message}</p>
					{image && (
						<img
							src={image}
							alt="push notification"
							className="w-full h-auto border rounded-lg border-gray-200 mt-2 max-h-40"
						/>
					)}
				</div>
			</div>
		</div>
	);
};
